import { ANNUAL_COVER_VALUE, COUPLE_GROUP_TYPE_VALUE, ERR_MSGS, FAMILY_GROUP_TYPE_VALUE, GROUP_GROUP_TYPE_VALUE, INDIVIDUAL_GROUP_TYPE_VALUE, MAX_NUM_PARTY_MEMBERS, REQ_ERR_MSGS, errorBoxes, } from '../constants';
import { isControl } from '../utils';
export default class Validation {
    constructor(formData, form) {
        this.formData = formData;
        this.form = form;
    }
    parseDate(dateString) {
        const [day, month, year] = dateString.split('/');
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }
    stripTime(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }
    validateFormInput() {
        const COVER_TYPE = 'coverType';
        const AREA = 'area';
        const START_DATE = 'startDate';
        const END_DATE = 'endDate';
        const MODE_KEYS = ['AYG', 'AMD', 'AMR', 'INF', 'DCH'];
        if (!this.formData.get(COVER_TYPE))
            return REQ_ERR_MSGS.coverType;
        if (!this.formData.get(AREA))
            return REQ_ERR_MSGS.area;
        if (!this.formData.get(START_DATE) &&
            this.formData.get(END_DATE) !== 'DD/MM/YYYY')
            return REQ_ERR_MSGS.startDate;
        if (!this.formData.get(END_DATE) &&
            this.formData.get(END_DATE) !== 'DD/MM/YYYY' &&
            this.formData.get(COVER_TYPE) !== 'MT_MT_N' &&
            this.formData.get(COVER_TYPE) !== 'MT_MT') {
            return REQ_ERR_MSGS.endDate;
        }
        const selectedStartDate = this.stripTime(this.parseDate(this.formData.get('startDate')));
        const today = this.stripTime(new Date());
        const startDateMustBeGreaterThanToday = selectedStartDate < today;
        if (startDateMustBeGreaterThanToday)
            return REQ_ERR_MSGS.startDateMustBeGreaterThanToday;
        const selectedEndDate = this.stripTime(this.parseDate(this.formData.get('endDate')));
        if (this.formData.get('coverType') !== ANNUAL_COVER_VALUE) {
            const endDateMustBeGreaterThanStartDate = selectedEndDate < selectedStartDate;
            if (endDateMustBeGreaterThanStartDate)
                return REQ_ERR_MSGS.endDateMustBeGreaterThanStartDate;
        }
        const packageSelected = this.formData.get('groupType');
        if (!packageSelected)
            return REQ_ERR_MSGS.packageSelection;
        return null;
    }
    displayError(inputValidation) {
        const reqErrorBox = this.form.querySelector(inputValidation.selector);
        reqErrorBox.classList.add('error', 'required');
        reqErrorBox.querySelector('.error__message').textContent =
            inputValidation.errMsg;
        reqErrorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errorBoxes
            .filter((ab) => !inputValidation.selector.includes(ab))
            .forEach((box) => {
            this.form
                .querySelector(`#${box}`)
                .classList.remove('error', 'required');
        });
        return {
            isValid: false,
            errMsg: inputValidation.errMsg,
        };
    }
    validateAgeField() {
        const MODE_KEYS = ['AYG', 'AMD', 'AMR', 'INF', 'DCH'];
        const totalPersons = MODE_KEYS.map((key) => Number.parseInt(this.formData.get(key)) || 0).reduce((acc, curr) => acc + curr, 0);
        this.formData.set('totalPartySize', totalPersons);
        if (totalPersons <= 0)
            return REQ_ERR_MSGS.personCount;
        return null;
    }
    validateAllInputForm() {
        var _a;
        const inputValidation = (_a = this.validateFormInput()) !== null && _a !== void 0 ? _a : this.validateAgeField();
        if (inputValidation) {
            const reqErrorBox = this.form.querySelector(inputValidation.selector);
            reqErrorBox.classList.add('error', 'required');
            reqErrorBox.querySelector('.error__message').textContent =
                inputValidation.errMsg;
            reqErrorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
            errorBoxes
                .filter((ab) => !inputValidation.selector.includes(ab))
                .forEach((box) => {
                this.form
                    .querySelector(`#${box}`)
                    .classList.remove('error', 'required');
            });
            return {
                isValid: false,
                errMsg: inputValidation.errMsg,
            };
        }
        errorBoxes.forEach((box) => {
            this.form.querySelector(`#${box}`).classList.remove('error', 'required');
        });
        const modalValidationResult = this.validateForm();
        if (!modalValidationResult.isValid) {
            // !!! START HERE
            // !!! REMOVE THIS CODE ONCE THE VARIANT WON
            const errorBox = this.form.querySelector(isControl()
                ? '.qq-packages-type--control'
                : '.qq-packages-type--variant');
            errorBox.classList.add('error');
            errorBox.querySelector('.error__message').textContent =
                modalValidationResult.errMsg;
            errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return modalValidationResult;
    }
    validateForm() {
        const MODE_KEYS = ['AYG', 'AMD', 'AMR', 'INF', 'DCH'];
        let meetsMinReqPartySize = false;
        const numberOfAdults70Plus = this.formData.get('AMR');
        const numberOfAdults65Plus = this.formData.get('AMD') +
            this.formData.get('AMR');
        const totalPartySize = MODE_KEYS.map((key) => Number.parseInt(this.formData.get(key)) || 0).reduce((acc, curr) => acc + curr, 0);
        const numberOfChildrenAndInfants = this.formData.get('INF') +
            this.formData.get('DCH');
        const numberOfAdults = numberOfAdults65Plus + this.formData.get('AYG');
        const _gt = this.formData.get('groupType');
        const exceedsMaxPartySize = totalPartySize > MAX_NUM_PARTY_MEMBERS;
        meetsMinReqPartySize = numberOfAdults > 0;
        const exceedsPartySizeForIND = _gt === INDIVIDUAL_GROUP_TYPE_VALUE && totalPartySize > 1;
        const exceedsPartySizeForCouples = _gt === COUPLE_GROUP_TYPE_VALUE &&
            (totalPartySize > 2 || numberOfAdults !== 2);
        const exceedsDateRangeAllowedForAdults64Plus = numberOfAdults65Plus > 0 &&
            this.formData.get('numberOfTripDays') > 31;
        const numberOfAdultsNotMetForFamily = _gt === FAMILY_GROUP_TYPE_VALUE &&
            (numberOfAdults < 1 || numberOfAdults > 2);
        const criteriaNotMetForFamilyPolicy = _gt === FAMILY_GROUP_TYPE_VALUE &&
            (numberOfChildrenAndInfants === 0 || numberOfAdultsNotMetForFamily);
        const numberOfPartyTooLessForGroupPolicy = _gt === GROUP_GROUP_TYPE_VALUE &&
            (numberOfAdults < 1 || totalPartySize < 2);
        const criteriaNotMetForKidsPolicy = (_gt === INDIVIDUAL_GROUP_TYPE_VALUE && numberOfChildrenAndInfants > 0) ||
            (_gt === GROUP_GROUP_TYPE_VALUE && numberOfChildrenAndInfants > 0);
        const criteriaCoupleNotMet = _gt === COUPLE_GROUP_TYPE_VALUE && numberOfChildrenAndInfants > 0;
        const isAgeBeyondAnnualMultiTripLimit = numberOfAdults70Plus > 0 &&
            this.formData.get('coverType') === ANNUAL_COVER_VALUE;
        const criteriaGrpMinNotMet = _gt === GROUP_GROUP_TYPE_VALUE && totalPartySize < 2;
        const criteriaGrpNoAdults = _gt === GROUP_GROUP_TYPE_VALUE && numberOfAdults < 1;
        const criteriaGrpMinorNotMet = _gt === GROUP_GROUP_TYPE_VALUE && numberOfChildrenAndInfants > 0;
        let errMsg = {
            isValid: true,
            errMsg: '',
        };
        const criteriaMappings = [
            {
                condition: criteriaGrpMinNotMet,
                message: ERR_MSGS.errorMsgGrpMinNotMet,
            },
            { condition: criteriaGrpNoAdults, message: ERR_MSGS.errorMsgGrpNoAdults },
            {
                condition: criteriaCoupleNotMet,
                message: ERR_MSGS.errorMSG_CoupleNotMet,
            },
            {
                condition: criteriaGrpMinorNotMet,
                message: ERR_MSGS.errorMSG_Grp_Minor,
            },
            {
                condition: criteriaNotMetForKidsPolicy,
                message: ERR_MSGS.errorMSG_kidCall,
            },
            {
                condition: exceedsMaxPartySize,
                message: ERR_MSGS.errorMSG_maxPartySize,
            },
            {
                condition: exceedsPartySizeForIND,
                message: ERR_MSGS.errorMSG_partySize_IND,
            },
            {
                condition: exceedsPartySizeForCouples,
                message: ERR_MSGS.errorMSG_partySize_CPL,
            },
            {
                condition: exceedsDateRangeAllowedForAdults64Plus,
                message: ERR_MSGS.errorMSG_exceedsDateRangeAllowedForAdults64Plus,
            },
            {
                condition: criteriaNotMetForFamilyPolicy,
                message: ERR_MSGS.errorMSG_partySize_FAM,
            },
            {
                condition: numberOfPartyTooLessForGroupPolicy,
                message: ERR_MSGS.errorMSG_partySize_GRP,
            },
            {
                condition: isAgeBeyondAnnualMultiTripLimit,
                message: ERR_MSGS.errorMsg_AgeBeyondAnnualMultiTripLimit,
            },
            {
                condition: !meetsMinReqPartySize,
                message: ERR_MSGS.errorMSG_minPartySize,
            },
        ];
        for (const criteria of criteriaMappings) {
            if (criteria.condition) {
                return {
                    isValid: false,
                    errMsg: criteria.message,
                };
            }
        }
        return errMsg;
    }
}
